// extracted by mini-css-extract-plugin
export default {"main":"menu_main__PKXEM","balance":"menu_balance__z5iUL","menu":"menu_menu__4hxZU","item":"menu_item__t3ymL","logout":"menu_logout__Eq5ek"};